export default __webpack_public_path__ + "static/media/two_conv_mppt_topology_full.cd5e5884.png";